import { render, staticRenderFns } from "./UserContentPopover.vue?vue&type=template&id=702301b4&scoped=true"
import script from "./UserContentPopover.vue?vue&type=script&lang=js"
export * from "./UserContentPopover.vue?vue&type=script&lang=js"
import style0 from "./UserContentPopover.vue?vue&type=style&index=0&id=702301b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702301b4",
  null
  
)

export default component.exports